<template>
  <div class="actionPlan">
    <div class="show add assessmentAdd">
      <GradeDetail :id="gradeId" :getDatas="getGradeData"></GradeDetail>
      <div class="addBox">
        <div class="title">学科行动计划-评估</div>
        <ul class="showlist">
          <li v-for="(item,index) in data.subjectStress||[]" :key="index">
            <span>
              <img src="~@img/xueyezixun/public/star.png" alt="">
              {{index}}
            </span>
            <div class="scores">学期目标：{{item?item[0]['targetScore']:''}}</div>
            <div v-for="(it,i) in item" :key="i">
              <div>阶段问题{{it.length>1?i+1:""}}：{{it.stageProblem}}</div>
              <div>阶段任务{{it.length>1?i+1:""}}：{{it.stageTask}}</div>
              <div class="right">
                <div>任务完成：{{it.taskComplete}}
                </div>
                <div>完成效果：{{it.completeEffect}}
                </div>
              </div>
            </div>
          </li>
          <li v-for="(item,index) in data.subjectCommon||[]" :key="index">
            <span>
              {{index}}
            </span>
            <div class="scores">学期目标：{{item?item[0]['targetScore']:''}}</div>
            <div v-for="(it,i) in item" :key="i">
              <div>阶段问题{{it.length>1?i+1:""}}：{{it.stageProblem}}</div>
              <div>阶段任务{{it.length>1?i+1:""}}：{{it.stageTask}}</div>
              <div class="right">
                <div>任务完成：{{it.taskComplete}}
                </div>
                <div>完成效果：{{it.completeEffect}}
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div class="title">学习习惯养成</div>
        <div>
          <circleName :name="'阶段学习习惯养成评估:'"></circleName>
          <div class="habit">
            <table v-for="(item,index) in data.subjectLearnHabit||[]" :key="index">
              <tbody>
              <tr>
                <td>阶段问题:</td>
                <td>
                  {{item.stageProblem}}
                </td>
                <td>
                  <span></span>
                  任务完成：{{item.taskComplete}}
                </td>
              </tr>
              <tr>
                <td>目标习惯:</td>
                <td>
                  {{item.targetHabit}}
                </td>
                <td>
                  <span></span>
                  完成效果：{{item.completeEffect}}
                </td>
              </tr>
              <tr>
                <td>行动方案：</td>
                <td>
                  {{item.actionPlan}}
                </td>
                <td>
                  <span></span>
                  是否继续：
                  <el-radio v-model="item.isContinue" :label="1"  disabled style="padding-left: 30px">是</el-radio>
                  <el-radio v-model="item.isContinue" :label="2" disabled>否</el-radio>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="title" style="margin-top: 30px">路径条件</div>
        <div>
          <circleName :name="'条件目标:'+data.consultRecord"></circleName>
          <circleName :name="'路径目标任务评估:'"></circleName>
          <div class="habit">
            <table v-for="(item,index) in data.subjectPathCondition||[]" :key="index">
              <tbody>
              <tr>
                <td>阶段目标:</td>
                <td>
                  {{item.stageTarget}}
                </td>
                <td>
                  <span></span>
                  任务完成：{{item.taskComplete}}
                </td>
              </tr>
              <tr>
                <td>阶段任务:</td>
                <td>
                  {{item.stageTask}}
                </td>
                <td>
                  <span></span>
                  完成效果：{{item.completeEffect}}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom" style="width: 300px;margin: 60px auto 0;display: flex;justify-content: space-between">
      <Button name="返回修改"
              @handleClick="$router.back()" :style="{borderRadius:'16px'}"></Button>
      <Button name="完成评估"  @handleClick="submit" :style="{borderRadius:'16px'}"></Button>
    </div>
  </div>
</template>
<script>
import MessageTitle from '@/components/xueyezixun/MessageTitle.vue'
import CircleName from "@/components/xueyezixun/CircleName";
import SummaryTitle from "@/components/xueyezixun/SummaryTitle";
import Button from "@/components/xueyezixun/Button";
import GradeDetail from './gradeDetailassessment'

export default {
  name: 'actionPlan',
  components:{MessageTitle ,CircleName,SummaryTitle,Button,GradeDetail },
  data() {
    return JSON.parse(window.sessionStorage.getItem('actionAssementPreview'))||{}
  },
  methods: {
    submit(){
      const {subjectStress,subjectCommon,subjectLearnHabit,subjectPathCondition} = this.data
      const {actionPlanId,interViewData,gradeId} = this
      let subjectStressTransfrom=[],subjectCommonTransfrom=[];
      Object.keys(subjectStress).forEach(item=>{
        subjectStress[item].forEach(it=>{
          subjectStressTransfrom.push(
              {
                id:it.id,
                subject:it.subject,
                taskComplete:it.taskComplete,
                completeEffect:it.completeEffect
              }
          )
        })
      })
      Object.keys(subjectCommon).forEach(item=>{
        subjectCommon[item].forEach(it=>{
          subjectCommonTransfrom.push(
              {
                id:it.id,
                subject:it.subject,
                taskComplete:it.taskComplete,
                completeEffect:it.completeEffect
              }
          )
        })
      })
      subjectLearnHabit&&subjectLearnHabit.forEach(item=>{
        delete item.actionPlan;
        delete item.stageProblem
        delete item.targetHabit;

      })
      subjectPathCondition&&subjectPathCondition.forEach(item=>{
        delete item.stageTarget
        delete item.stageTask
      })
      this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.implement.assessmentScore, {
        id:actionPlanId,
        interviewRecord:interViewData,
        subjectStress: subjectStressTransfrom,
        subjectCommon:subjectCommonTransfrom,
        subjectLearnHabit:subjectLearnHabit,
        subjectPathCondition:subjectPathCondition
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          let data=res.data;
          sessionStorage.removeItem('actionAssementPreview')
          this.$router.push( {path:'/consultant/minestudent/main/implement/actionplan/assessmentShow',
            query:{gradeId:this.gradeId,actionPlanId:data.data.id}})
        }else{

        }
      })
    }
  },
  mounted() {

  }
}
</script>
<style scoped lang="less">
@import "./css/index.less";
</style>